import React, { useEffect, useState, useCallback, useMemo } from "react";
import Styles from "./Unified_Ledger.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import OngoingBilateralTable from "./OngoingConnections/Ongoing_Connections_Table";
import OngoingRATable from "./OngoingConnections/Ongoing_RA_Table";

import {
  fetchBilateralLedgerOngoing,
  fetchRALedgerOngoing,
  fetchCBLedgerOngoing
} from "../../../../Redux/Slices/unifiedLedgerSlice";

const UnifiedLedger = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("Bilateral");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userSelectedTab, setUserSelectedTab] = useState(false);

  const {
    bilateralLedgerOngoingData,
    raLedgerOngoingData,
    cbLedgerOngoingData,
    loading,
    error,
  } = useSelector((state) => state.unifiedLedger);

  const ledgerConfig = {
  Bilateral: {
    fetcher: fetchBilateralLedgerOngoing,
    data: bilateralLedgerOngoingData,
  },
  "Reverse Auction": {
    fetcher: fetchRALedgerOngoing,
    data: raLedgerOngoingData,
  },
   "Competitive Bidding": {
    fetcher: fetchCBLedgerOngoing,
    data: cbLedgerOngoingData,
  },
};

const activeData = ledgerConfig[activeTab].data;
console.log("hereee",ledgerConfig[activeTab])

useEffect(() => {
  dispatch(ledgerConfig[activeTab].fetcher({ currentPage, size: itemsPerPage }));
}, [activeTab, currentPage, itemsPerPage]);

useEffect(() => {
  setCurrentPage(0);
}, [activeTab]);


  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  );

  console.log("ROLE IS", role);

  console.log("State of unified ledger", loading);

  const mapBilateral = (item, generator, consumer) => {
  let source = null;
  let counterparty = null;

  if (role == "GENERATOR") {
    source = item.capacityGenerator;
    counterparty = item.capacityConsumer;
  } else if (role == "CONSUMER") {
    source = item.capacityConsumer;
    counterparty = item.capacityGenerator;
  }

  return {
    listingId: item.id,
    listingName: source?.name,
    initialMargin: item?.initialMargin ?? "-",
    emd: item?.emd ?? "-",
    listingExpiryDate: source?.listingExpDate ?? "-",
    termExpiryDate: source?.termsExpDate ?? "-",
    status: item?.status,
    bilateralConnections: item?.bilateralConnections,
    counterparty,
    item,
    source,
  };
};

const mapReverseAuction = (item) => {
  return {
    listingId: item.id,
    tenderNumber:item.tenderNumber,
    auctionNumber:item.auctionNumber,
    tenderStartDateTime:item.tenderStartDateTime,
    tenderCloseDateTime:item.tenderCloseDateTime,
    bidStartDateTime:item.bidStartDateTime,
    bidCloseDateTime:item.bidCloseDateTime,
    emdPerMw:item.emdPerMw,
    tenderStatus:item.tenderStatus,
    bilateralConnection: item?.bilateralConnection,
    item,
  };
};

const mapperConfig = {
  Bilateral: mapBilateral,
  "Reverse Auction": mapReverseAuction,
  "Competitive Bidding": mapReverseAuction,
};

  console.log("In unified ledger with data", activeData);


  const { generator, consumer } = useSelector((state) => state.persistedReducer);
    // if (!Array.isArray(bilateralLedgerOngoingData?.data?.page)) return [];
    // if (!Array.isArray(activeData?.data?.page)) return [];

    const pagedItemsOngoing = useMemo(() => {
    if (!Array.isArray(activeData?.data?.page)) return [];

    const mapper = mapperConfig[activeTab];
 
    return activeData.data.page.map(item =>
    activeTab === "Bilateral"
      ? mapper(item, generator, consumer)
      : mapper(item)
  );
}, [activeTab, activeData, generator, consumer]);

  const activeListingIdOngoing = pagedItemsOngoing.map((item) => item.listingId);

  const paginatedCurrentPageOngoing =
    activeData?.data?.currentPage ?? 0;

  const paginatedSizeOngoing =
    activeData?.data?.size ?? 10;

  const totalElementsOngoing =
    activeData?.data?.totalElements ?? pagedItemsOngoing.length;

  const totalPagesOngoing =
    activeData?.data?.totalPages ?? 0;


  useEffect(() => {
    if (location.state?.activeTab) {
      if (location.state.activeTab === "Reverse Auction") {
        setActiveTab("Reverse Auction");
      } else if (location.state.activeTab === "Forward Auction") {
        setActiveTab("Forward Auction");
      } else if (location.state.activeTab === "Competitive Bidding") {
        setActiveTab("Competitive Bidding");
      } else {
        setActiveTab("Bilateral");
      }

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (activeTab === "Bilateral") {
      dispatch(fetchBilateralLedgerOngoing({ currentPage, size: itemsPerPage }));
      console.log("Dispatch done");
      console.log("this is dispatch data", bilateralLedgerOngoingData)
    } else if (activeTab === "Reverse Auction") {
      dispatch(fetchRALedgerOngoing({ currentPage, size: itemsPerPage }));
      console.log("dispatch ra");
      console.log("this is dispatch data", raLedgerOngoingData)
    }
    else if (activeTab === "Forward Auction") {
      // dispatch(fetchLedgerOngoing({ currentPage, size: itemsPerPage }));
      console.log("dispatch fa");
    }
    else if (activeTab === "Competitive Bidding") {
       dispatch(fetchCBLedgerOngoing({ currentPage, size: itemsPerPage }));
      console.log("dispatch cb");
    }
  }, [dispatch, currentPage, itemsPerPage, activeTab]);

  useEffect(() => {
    setCurrentPage(0);
  }, [activeTab]);


  const handleTabClick = useCallback((tabName) => {
    setActiveTab(tabName);
    setUserSelectedTab(true);
  }, []);


  return (
    <>
      <div className={Styles.bankingSearchMainCont}>
        <div className={Styles.bankingSearchHead}>
          <div className={Styles.bankingLedgerBack}>
            <div
              className={Styles.receivedBackButton}
              onClick={() => navigate(`/banking`)}
            >
              <ArrowBackIosIcon
                style={{ width: "10px", height: "10px", paddingRight: "5%" }}
              />
              Back
            </div>
            <div className={Styles.receivedHeading}>Ongoing Connections</div>
          </div>
          <div className={Styles.sideButtonsLedger}>
            <div
              className={
                activeTab === "Bilateral"
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Bilateral")}
            >
              Bilateral
            </div>
            <div
              className={
                activeTab === "Reverse Auction"
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Reverse Auction")}
            >
              Reverse Auction
            </div>
            {/* <div
              className={
                activeTab === "Forward Auction"   
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Forward Auction")}
            >
              Forward Auction
            </div> */}
            <div
              className={
                activeTab === "Competitive Bidding"
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Competitive Bidding")}
            >
              Competitive Bidding
            </div>
          </div>
        </div>

        <div className={Styles.activeTableConnections}>
          {activeTab === "Reverse Auction" && (
            <div style={{ padding: "20px 2px 20px 2px" }}>
                <OngoingRATable
                isLoading={loading}
                data={pagedItemsOngoing}
                activeListingId={activeListingIdOngoing}
                currentPage={paginatedCurrentPageOngoing}
                itemsPerPage={paginatedSizeOngoing}
                totalCount={totalElementsOngoing}
                onPageChange={setCurrentPage}
                 isCB={false}
              />
            </div>
          )}
          {activeTab === "Bilateral" && (
            <div style={{ padding: "20px 2px 20px 2px" }}>
              <OngoingBilateralTable
                isLoading={loading}
                data={pagedItemsOngoing}
                activeListingId={activeListingIdOngoing}
                currentPage={paginatedCurrentPageOngoing}
                itemsPerPage={paginatedSizeOngoing}
                totalCount={totalElementsOngoing}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
          {activeTab === "Forward Auction" && (
            <div style={{ padding: "20px 2px 20px 2px" }}>
              <h3>Forward Auction</h3>
              <p>This is the Forward Auction tab.</p>
            </div>
          )}
          {activeTab === "Competitive Bidding" && (
              <div style={{ padding: "20px 2px 20px 2px" }}>
                <OngoingRATable
                isLoading={loading}
                data={pagedItemsOngoing}
                activeListingId={activeListingIdOngoing}
                currentPage={paginatedCurrentPageOngoing}
                itemsPerPage={paginatedSizeOngoing}
                totalCount={totalElementsOngoing}
                onPageChange={setCurrentPage}
                isCB={true}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UnifiedLedger;
